(function(angular, module) {var ChangeLogItemComponent, ChangeLogItemController;

ChangeLogItemController = function(ChangeLogService, $element, $scope) {
  'ngInject';
  $scope.$program = this.program;
  $element.toggleClass('draft', !this.item.is_published);
  $element.toggleClass('published', this.item.is_published);
  this.templateUrl = ChangeLogService.templateUrl(this.item);
};

ChangeLogItemComponent = {
  controller: ChangeLogItemController,
  controllerAs: 'changeLogItem',
  templateUrl: 'changeLog/item',
  bindings: {
    item: '=',
    program: '=?'
  }
};

module.component('changeLogItem', ChangeLogItemComponent);
})(angular, angular.module("changeLog"));